import { request } from "@/utils/request";

//热门站点
export const getHotSites = (data) => {
  return request({
    url: "/user/public/getHotSites",
    method: "POST",
    data,
  });
};

//用户已首营站点
export const queryUserFirstSellSites = () => {
  return request({
    url: "/user/mall/queryUserFirstSellSites",
    method: "GET",
  });
};

//用户常用站点
export const queryUserTopSellerCompany = () => {
  return request({
    url: "/user/mall/queryUserTopSellerCompany",
    method: "GET",
  });
};

//用户所有站点
export const queryUserAllCompany = (data) => {
  return request({
    url: "/user/public/queryUserAllCompany",
    method: "POST",
    data,
  });
};
